/* Amelia & Grace — Urgency Badge (product pages only)
   - Shows: "Only 4–7 pieces left in stock!"
   - Random each page load
   - Renders ONLY on product templates (no homepage)
*/
(function () {
  function onReady(fn){
    if (document.readyState === 'complete' || document.readyState === 'interactive') setTimeout(fn,0);
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function $(s,r){ return (r||document).querySelector(s); }

  // Run only on product pages
  function isProductPage(){
    if (document.body && document.body.classList.contains('template-product')) return true;
    if ($('script[type="application/json"][data-product-json]')) return true;
    if ($('form[action*="/cart/add"]')) return true;
    return false;
  }

  function ensureStyles(){
    if ($('#ag-urgency-style')) return;
    var s = document.createElement('style');
    s.id = 'ag-urgency-style';
    s.textContent =
      '.ag-urgency{display:flex;align-items:center;gap:.6rem;margin:.5rem 0}' +
      '.ag-urgency .dot{position:relative;width:.55rem;height:.55rem;border-radius:9999px;background:#dc2626}' +
      '.ag-urgency .dot::before{content:"";position:absolute;inset:-.3rem;border-radius:9999px;background:#dc2626;opacity:.12}' +
      '.ag-urgency .dot::after{content:"";position:absolute;inset:-.15rem;border-radius:9999px;background:#dc2626;opacity:.35;animation:ag-ripple 1.6s ease-out infinite}' +
      '@keyframes ag-ripple{0%{transform:scale(.6);opacity:.45}70%{transform:scale(1.9);opacity:.08}100%{transform:scale(2.1);opacity:0}}' +
      '.ag-urgency .txt{font-size:.9rem;line-height:1.3;font-weight:400;color:#111}';
    document.head.appendChild(s);
  }

  function render(){
    // Anchor ONLY on product elements; if none found, abort (don’t render on Home)
    var anchor = $('form[action*="/cart/add"]') || $('.product-form') || $('[data-product-price]');
    if (!anchor) return;

    ensureStyles();

    var qty = Math.floor(Math.random() * 4) + 4; // 4–7
    var badge = $('#ag-urgency');
    if (!badge) {
      badge = document.createElement('div');
      badge.id = 'ag-urgency';
      badge.className = 'ag-urgency';
      badge.innerHTML = '<span class="dot" aria-hidden="true"></span><span class="txt"></span>';
      // place just ABOVE the Add-to-Cart area
      anchor.parentNode && anchor.parentNode.insertBefore(badge, anchor);
    }
    var txt = $('.txt', badge);
    if (txt) txt.textContent = 'Only ' + qty + ' pieces left in stock!';
    badge.style.display = '';
  }

  function init(){
    if (!isProductPage()) return;   // hard stop on non-product pages
    render();
  }

  onReady(init);
})();


